import { useState, useEffect } from "react";
import { Box, TextField, Button, Typography, Card, CardContent, InputAdornment } from "@mui/material";
import LockIcon from '@mui/icons-material/Lock';
import { useNavigate, useSearchParams } from "react-router-dom";
import { usePostDataFetch } from "../../utils/useDataFetch";

const ResetPassword = () => {
    const { data: resetData, error: resetError, isLoading: resetLoading, postData: postReset } = usePostDataFetch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [localError, setLocalError] = useState("");

    useEffect(() => {
        if (!token) {
            setLocalError("Kein Reset-Token gefunden. Bitte fordere einen neuen Link an.");
        }
    }, [token]);

    useEffect(() => {
        if (resetData?.success) {
            alert(resetData.message || "Passwort wurde erfolgreich geändert. Du kannst dich jetzt einloggen.");
            navigate("/auth");
        }
    }, [resetData, navigate]);

    const handleReset = (e) => {
        e.preventDefault();
        setLocalError("");
        if (password !== confirmPassword) {
            setLocalError("Die Passwörter stimmen nicht überein.");
            return;
        }
        postReset({ url: "/auth/reset-password", aBody: { token, newPassword: password }, skipAuth: true });
    };

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default', p: 2 }}>
            <Card sx={{ maxWidth: 450, width: '100%', boxShadow: 6, borderRadius: "12px" }}>
                <CardContent sx={{ p: { xs: 3, sm: 5 } }}>
                    <Box sx={{ textAlign: 'center', mb: 4 }}>
                        <Typography variant="h4" fontWeight="900" color="primary" sx={{ mb: 1 }}>Passwort zurücksetzen</Typography>
                        <Typography variant="body1" color="text.secondary">Bitte gib dein neues Passwort ein.</Typography>
                    </Box>

                    <form onSubmit={handleReset}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                            <TextField
                                label="Neues Passwort"
                                type="password"
                                required
                                fullWidth
                                variant="outlined"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start"><LockIcon color="action" /></InputAdornment>,
                                }}
                            />
                            <TextField
                                label="Passwort bestätigen"
                                type="password"
                                required
                                fullWidth
                                variant="outlined"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start"><LockIcon color="action" /></InputAdornment>,
                                }}
                            />

                            {(localError || resetError || (resetData && !resetData.success)) && (
                                <Typography color="error" variant="body2" align="center" sx={{ bgcolor: 'error.main', color: 'error.contrastText', p: 1, borderRadius: "12px" }}>
                                    {localError || (typeof resetError === 'object' ? resetError.message : resetError) || resetData?.message}
                                </Typography>
                            )}

                            <Button 
                                type="submit" 
                                variant="contained" 
                                color="primary" 
                                size="large" 
                                fullWidth 
                                disabled={resetLoading || !token} 
                                sx={{ mt: 1, py: 1.8, fontSize: '1.1rem', fontWeight: 'bold', borderRadius: "12px" }}
                            >
                                {resetLoading ? "Wird gespeichert..." : "Passwort speichern"}
                            </Button>
                            
                            <Button variant="text" color="secondary" onClick={() => navigate("/auth")} sx={{ mt: 1 }}>
                                Zurück zum Login
                            </Button>
                        </Box>
                    </form>
                </CardContent>
            </Card>
        </Box>
    );
};

export default ResetPassword;
